import React, { useMemo } from "react";
import MiniHeaders from "./mini-headers";
import ImageCarousel from "./image-carousel";

const Opinion = () => {
    const opinionImageNameList = useMemo(() => {
        const list = [];
        for (let i = 1; i < 26; i++) {
            list.push(`opinion-image-${i}`);
        }
        return list;
    }, []);

    return (
        <div className="opinion">
            <div className="wrapper blocks-wrapper">
                <MiniHeaders headerName="Կարծիքներ" />
                <div>
                    <ImageCarousel items={opinionImageNameList} />
                </div>
            </div>
        </div>
    );
};

export default Opinion;
